import React from "react";
import { SuppliersContextProvider } from "../Context/SuppliersContext";
import { Box } from "@chakra-ui/react";
import SuppliersList from "./SuppliersList";
import { useHistory } from "react-router-dom";
import Body from "../Common/Body";

const Suppliers = () => {
  const history = useHistory();

  return (
    <SuppliersContextProvider>
      <Body title={"Lista de proveedores"}>
        <Box>
          <SuppliersList></SuppliersList>
        </Box>
      </Body>
    </SuppliersContextProvider>
  );
};

export default Suppliers;
